module.exports = __webpack_public_path__ + "static/img/Bachelor_010524.2024dfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010524.jpg
// module id = 179
// module chunks = 0